import { GuestWaitingList, LookEntity } from '@seaters/constants';
import { Card, Typography } from 'antd';
import dayjs from 'dayjs';

import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import { getBrandColors, getLocale } from './utils';
import { primaryColor } from '@seaters/ui';

dayjs.extend(LocalizedFormat);

const { Text, Title } = Typography;

type TitleCardProps = {
  fanGroupData: LookEntity;
  waitingListData: GuestWaitingList;
};

export function TitleCard({ fanGroupData, waitingListData }: TitleCardProps) {
  const getMinifiedDate = () => {
    const locale = getLocale();

    const date = dayjs(waitingListData.eventStartDate)
      .locale(locale)
      .format('HH:mm DD/MM/YYYY');
    return date;
  };

  const title =
    waitingListData.translatedExperienceName ||
    waitingListData.translatedEventName;

  const brandTextColor = getBrandColors(fanGroupData.color, primaryColor).text;

  return (
    <Card
      title={
        <Title
          level={1}
          style={{ color: brandTextColor, fontSize: 24 }}
          data-testid="invitationTitle"
        >
          {title}
        </Title>
      }
      extra={
        <Text strong style={{ color: brandTextColor }}>
          {getMinifiedDate()}
        </Text>
      }
      styles={{
        title: {
          marginRight: 24,
          whiteSpace: 'unset',
        },
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          flexDirection: 'row-reverse',
        }}
      >
        <Text strong style={{ color: '#515151' }}>
          {waitingListData.translatedVenueName}
        </Text>
        <Text strong style={{ color: '#515151' }}>
          {waitingListData.displayName}
        </Text>
      </div>
    </Card>
  );
}
